<section>
  <h2>Alta de vehiculo</h2>
  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">Marca</span>
    <input id="Marca" [(ngModel)]="vehiculo.marca" type="text" class="form-control" aria-label="Marca"
      aria-describedby="inputGroup-sizing-default">
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">Modelo</span>
    <input id="Modelo" [(ngModel)]="vehiculo.modelo" type="text" class="form-control" aria-label="Modelo"
      aria-describedby="inputGroup-sizing-default">
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">Año</span>
    <input id="Ano" [(ngModel)]="vehiculo.ano" type="text" class="form-control" aria-label="Ano"
      aria-describedby="inputGroup-sizing-default">
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">Patente</span>
    <input id="Patente" [(ngModel)]="vehiculo.patente" type="text" class="form-control" aria-label="Patente"
      aria-describedby="inputGroup-sizing-default">
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">Detalle</span>
    <input id="Detalle" [(ngModel)]="vehiculo.detalle" type="text" class="form-control" aria-label="Detalle"
      aria-describedby="inputGroup-sizing-default">
  </div>

  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
    <button type="button" class="btn btn-primary" (click)="guardar()" [mat-dialog-close]="vehiculo">Guardar</button>
  </div>

</section>